import React from 'react';
import styled from "styled-components";
import Title from './Title';
// import pricing1 from "assets/pricing1.png";
// import pricing2 from "assets/pricing2.png";
// import play from "assets/play.png";
import { motion } from "framer-motion";
import { useScroll } from "./useScroll";
import { pricingAnimation } from "animation";

function Pricing() {
  const [element, controls] = useScroll();
  const plans = [
    {
      name: "Services",
      price: 28,
    },
    {
      name: "Women",
      price: 35,
    },
    {
      name: "Facial",
      price: 45,
    },
    {
      name: "Highlights",
      price: 80,
    },


  ];

  const data = [
    {
      value: "Hot Oil $35",
      type: "Women",
    },
    {
      value: "Cold Wave $60",
      type: "Women",
    },
    {
      value: "Hair Shampoo $12",
      type: "Women",
    },
    {
      value: "Iron(minimum) $30",
      type: "Women",
    },
    {
      value: "Blow Dry (minimum) $28",
      type: "Women",
    },
    {
      value: "Hair Keratin (minimum) $120",
      type: "Women",
    },
    {
      value: "Hair-up $75",
      type: "Women",
    },
    {
      value: "Repo/Retouch $50",
      type: "Women",
    },
    {
      value: "Hair Rebonding (minimum) $200",
      type: "Women",
    },
    {
      value: "Facial Wax from $45 to $50",
      type: "Facial",
    },
    {
      value: "Facial Regular $100",
      type: "Facial",
    },
    {
      value: "Facial with Laser $120",
      type: "Facial",
    },
    {
      value: "Eyebrow Threading $15",
      type: "Facial",
    },
    {
      value: "Eyebrow Tinting $15",
      type: "Facial",
    },
    {
      value: "Manicure $28",
      type: "Services",
    },
    {
      value: "Pedicure $35",
      type: "Services",
    },
    {
      value: "Foot Spa $50",
      type: "Services",
    },
    {
      value: "Brazillian Wax $65 ",
      type: "Services",
    },
    {
      value: "Bikini Line Wax $28 ",
      type: "Services",
    },
    {
      value: "Ear Piercing $40 ",
      type: "Services",
    },
    {
      value: "Men's Colour w/ Hair Cut $80",
      type: "Highlights",
    },
    {
      value: "Hair Color (Tube @ 50ml minimum) $50",
      type: "Highlights",
    },
    {
      value: "Hair Higlights (frosting Cap) $50",
      type: "Highlights",
    },
    {
      value: "Hair Color Labour (per Tube) $30",
      type: "Highlights",
    },
    {
      value: `Hair Highlishts Via Foils
      (Depending on Length of Hair)
      `,
      type: "Highlights",
    },
  ]

  return (
    <Section ref={element}>
      <Title value="pricing" />
      <div className="background">
        {/* ... (existing background images) */}
      </div>
      <div className="pricing__title">
        <h2>Price Menu</h2>
        <h3>Price may vary</h3>
      </div>
      <div className="pricing">
        {plans.map(({ name, price }, index) => (
          <motion.div
            className="pricing__plan"
            key={index}
            variants={pricingAnimation}
            animate={controls}
            transition={{
              delay: 0.03,
              type: "tween",
              duration: 0.8,
            }}
          >
            <div className="pricing__plan__name">
              <h2>{name}</h2>
              <div className="pricing__plan__name__price">
                <span>$</span>
                <p>{price}</p>
              </div>
            </div>
            <div className="pricing__plan__content">
              <ul className={`pricing__plan__content__features ${name.toLowerCase()}`}>
                {data
                  .filter(({ type }) => type === name)
                  .map(({ value }, index2) => (
                    <li key={index2}>{value}</li>
                  ))}
              </ul>
              <div className="pricing__plan__content__actions">
                {/* <img src={play} alt="Order Now" /> */}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}

const Section = styled.section`
min-height: 100vh;
padding: 5rem 0;
position: relative;
overflow: hidden;
.background {
  .bg1 {
    position: absolute;
    top: -60%;
    left: -5%;
    z-index: -1;
  }
  .bg2 {
    position: absolute;
    right: 0;
    bottom: 5rem;
  }
}
.pricing__title {
  margin: 6rem 10rem;
  p {
    color: var(--secondary-color);
    text-transform: uppercase;
    letter-spacing: 0.2rem;
  }
  h2 {
    color: var(--primary-color);
    font-size: 2rem;
  }
}
.pricing {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0 10rem;
  &__plan {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    &:nth-child(2) {
      .pricing__plan__content {
        padding: 0 5rem;
        border-left: 0.2rem solid var(--primary-color);
        border-right: 0.2rem solid var(--primary-color);
      }
    }
    &__name {
      background-color: var(--primary-color);
      width: 15rem;
      height: 15rem;
      border-radius: 10rem;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: var(--secondary-color);
      h2 {
        font-size: 2rem;
        line-height: 1.3rem;
      }
      &__price {
        color: #fff;
        display: flex;
        position: relative;
        span {
          position: absolute;
          top: 1rem;
          left: -0.9rem;
          font-size: 1.3rem;
        }
        p {
          font-size: 4rem;
          font-weight: bold;
        }
      }
    }
    &__content {
      &__features {
        list-style-type: none;
        text-align: center;
        color: var(--primary-color);
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        .line {
          text-decoration: line-through;
        }
        margin-bottom: 2rem
      }
      &__actions {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: var(--primary-color);
        gap: 0.5rem;
        span {
          text-transform: uppercase;
        }
      }
    }
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 
  padding: 1rem;
  background-color: var(--secondary-color);
  .pricing__title {
    margin: 0;
    padding: 0 2rem;
    text-align: center;
    h2 {
      font-size: 1.3rem;
    }
  }
  .background {
    display: none;
  }
  .pricing {
    grid-template-columns: 1fr;
    padding: 1rem;
    gap: 4rem;
    &__plan {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
      &__name {
        height: 10rem;
        width: 10rem;
        h2 {
          font-size: 1.5rem;
        }
        &__price {
          p {
            font-size: 3rem;
          }
        }
      }
      &:nth-child(2) {
        .pricing__plan__content {
          padding: 0rem;
          border: none;
        }
      }
    }
  }
}
`;
export default Pricing